import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import IconLogoGraphic from './Icons/logo-graphic';
import LogoFull from './Icons/logo-full';
import styles from './icon.scss';
import '@fortawesome/fontawesome-pro/css/all.css';

const getStyles = classNames.bind(styles);
const jllIconClass = 'icon';

const Icon = props => {
    const IconClasses = getStyles(jllIconClass, props.className);
    const Element = props.tag || 'span';

    const iconAttributes = {
        ...props,
        className: IconClasses
    };

    const icons = {
        'jll-logo-graphic-regular': <IconLogoGraphic {...iconAttributes} />,
        'jll-logo-regular': <LogoFull {...iconAttributes} />
    };

    if (props.type === 'jll') {
        if (props.name in icons) {
            return icons[props.name];
        }
        return null;
    }

    return <Element className={props.className} {...props} />;
};

Icon.propTypes = {
    /** The class of the svg icon. "className" prop should be used for setting a class for svg icon styling in scss, css (fill, stroke) */
    className: PropTypes.string,
    /** The height of the svg icon. If not declared, icon will not be displayed */
    height: PropTypes.number,
    /** The name of the svg icon. Name is needed to identify the specific icon from the icons list */
    name: PropTypes.string,
    /** The role of the svg icon. By default role is presentation, for correct accessibility usage in most cases */
    role: PropTypes.string,
    /** The stroke size of the svg icon. This prop should be used when it is needed to increase svg icons paths width */
    strokeWidth: PropTypes.number,
    /** The type of the icon, either font-awesome library or custom JLL icons */
    type: PropTypes.oneOf(['fa', 'jll']),
    /** The width of the svg icon. If not declared, icon will not be displayed */
    width: PropTypes.number
};

Icon.defaultProps = {
    className: '',
    height: undefined,
    name: '',
    role: 'presentation',
    strokeWidth: undefined,
    type: 'fa',
    width: undefined
};

export default Icon;
